import { formatDistance } from 'date-fns';
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { MapContainer, Marker, Polygon, TileLayer, Tooltip } from 'react-leaflet';
import { Icon } from 'leaflet';

function Map() {
    const TRAFFIC_LIGHT_COLOURS_LOOKUP = {
        green: '#2AAD27',
        amber: '#CAC428',
        red: '#CB2B3E',
    };

    const createMarkerIcon = (colour) => new Icon({
        iconUrl: `https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-${colour === 'amber' ? 'yellow' : colour}.png`,
        shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41]
    })

    const createHandSanitizerIcon = () => new Icon({
        iconUrl: `/images/marker-hand-sanitizer.png`,
        iconSize: [41, 41],
        iconAnchor: [20, 41]
    })

    const [sensors, setSensors] = useState([]);
    const [handSanitizers, setHandSanitizers] = useState([
        {
            name: 'Lands Lane junction with Commercial Street',
            latitude: 53.797447,
            longitude: -1.543673
        },
        {
            name: 'Briggate junction with King Edward Street',
            latitude: 53.797774,
            longitude: -1.542159
        },
        {
            name: 'Albion Street junction with Bond Street',
            latitude: 53.797385,
            longitude: -1.545160
        },
    ]);

    useEffect(() => {
        fetch('/sensors')
            .then(response => response.json())
            .then(data => setSensors(data))
            .catch(error => console.log(error));
    }, []);

    return (
        <MapContainer center={[53.820631018595776, -1.610293062625851]} zoom={11} scrollWheelZoom={true} style={{ height: '100%' }}>
            <TileLayer
                attribution='&copy; <a href="https://stadiamaps.com/">Stadia Maps</a>, &copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors'
                url="https://tiles.stadiamaps.com/tiles/osm_bright/{z}/{x}/{y}{r}.png"
            />
            {sensors.map((sensor, index) => {
                return (
                    <React.Fragment key={index}>
                        <Polygon pathOptions={{ color: TRAFFIC_LIGHT_COLOURS_LOOKUP[sensor.traffic_light] }} positions={sensor.polygon}>
                            <Marker
                                position={[sensor.latitude, sensor.longitude]}
                                icon={createMarkerIcon(sensor.traffic_light)}
                            >
                                <Tooltip direction="bottom">
                                    <h3 style={{ textAlign: 'center' }}>{sensor.name}</h3>

                                    <p>
                                        Updated <strong>{formatDistance(new Date(sensor.updated_at), new Date(), { addSuffix: true, includeSeconds: true })}</strong>.
                                    </p>
                                </Tooltip>
                            </Marker>
                        </Polygon>
                    </React.Fragment>
                )
            })}
            {handSanitizers.map((handSanitizer, index) => {
                return (
                    <React.Fragment key={index}>
                        <Marker
                            position={[handSanitizer.latitude, handSanitizer.longitude]}
                            icon={createHandSanitizerIcon()}
                        />
                    </React.Fragment>
                )
            })}
        </MapContainer >
    );
}

export default Map;

if (document.getElementById('map')) {
    ReactDOM.render(<Map />, document.getElementById('map'));
}
